/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY
// See angular/tools/gulp-tasks/cldr/extract.js

export default [
  [
    ['полн.', 'полд.', 'утра', 'дня', 'вечера', 'ночи'], ,
    ['полночь', 'полдень', 'утра', 'дня', 'вечера', 'ночи']
  ],
  [
    ['полн.', 'полд.', 'утро', 'день', 'веч.', 'ночь'], ,
    ['полночь', 'полдень', 'утро', 'день', 'вечер', 'ночь']
  ],
  [
    '00:00', '12:00', ['04:00', '12:00'], ['12:00', '18:00'], ['18:00', '24:00'],
    ['00:00', '04:00']
  ]
];
